import { useState } from "react";
import { toast } from "sonner";
import { FullBleedHero } from "../components/FullBleedHero";
import { Phone, WhatsappLogo, EnvelopeSimple, MapPin } from "@phosphor-icons/react";

const channels = [
  { icon: Phone, t: "Investor Helpline", a: "+91 22 6895 1234", b: "Mon – Sat, 10 AM – 7 PM" },
  { icon: WhatsappLogo, t: "WhatsApp Support", a: "+91 81212 12345", b: "Chat with us on WhatsApp" },
  { icon: EnvelopeSimple, t: "Email Us", a: "investors@ebgfincorp.com", b: "We typically reply within 24 hours" },
  { icon: MapPin, t: "Registered Office", a: "EBG House, 123 Business District", b: "Bandra (E), Mumbai — 400051" },
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const inputCls = "w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-navy-950 placeholder:text-gray-400 focus:border-gold focus:ring-1 focus:ring-gold focus:outline-none transition-colors";

  const submit = (e) => { e.preventDefault(); toast.success("Message sent. Our team will reach out shortly."); setForm({ name: "", email: "", phone: "", message: "" }); };

  return (
    <div data-testid="contact-page">
      <FullBleedHero
        image="/contact-hero.png"
        alt="A lighthouse casting a warm golden beam across dark water"
        eyebrow="Get in Touch"
        title={<>We're here to guide<br />you on your <span className="gold-text italic">journey.</span></>}
        subtitle="Like a lighthouse across still waters, our investor relations team is your steady point of contact — reach out and we'll guide you every step of the way."
      />

      <div className="px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="space-y-4">
          {channels.map((c) => (
            <div key={c.t} className="bg-navy-900 border border-white/10 rounded-xl p-5 flex items-start gap-4">
              <div className="grid place-items-center w-12 h-12 rounded-lg bg-gold/10 border border-gold/20 flex-shrink-0"><c.icon size={22} className="text-gold" weight="light" /></div>
              <div><p className="text-sm text-ebg-muted">{c.t}</p><p className="text-white font-medium mt-0.5">{c.a}</p><p className="text-xs text-ebg-muted mt-0.5">{c.b}</p></div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-2xl">
          <h2 className="font-display text-3xl text-navy-950 mb-6">Send us a message</h2>
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <div><label className="text-xs font-medium text-gray-600 mb-1.5 block">Full Name</label><input data-testid="contact-name" required placeholder="Enter your full name" value={form.name} onChange={set("name")} className={inputCls} /></div>
            <div><label className="text-xs font-medium text-gray-600 mb-1.5 block">Email Address</label><input data-testid="contact-email" type="email" required placeholder="Enter your email address" value={form.email} onChange={set("email")} className={inputCls} /></div>
            <div><label className="text-xs font-medium text-gray-600 mb-1.5 block">Mobile Number</label>
              <div className="flex gap-2"><span className="grid place-items-center px-3 bg-gray-50 border border-gray-200 rounded-lg text-navy-950 text-sm">+91</span><input data-testid="contact-phone" placeholder="Enter your mobile number" value={form.phone} onChange={set("phone")} className={inputCls} /></div>
            </div>
            <div><label className="text-xs font-medium text-gray-600 mb-1.5 block">Message</label><textarea data-testid="contact-message" required rows={4} placeholder="How can we help you?" value={form.message} onChange={set("message")} className={inputCls} /></div>
            <button data-testid="contact-submit" className="w-full btn-gold py-3 rounded-lg">Send Message</button>
          </form>
        </div>
        </div>
      </div>
    </div>
  );
}
